<section class="survey-history" aria-labelledby="survey-history-title">
  <h2 id="survey-history-title" class="survey-history__title">
    Animal History
  </h2>

  <div class="survey-history__divider" aria-hidden="true"></div>

  @if (errorMessage()) {
    <p class="survey-history__message" role="status">
      {{ errorMessage() }}
    </p>
  } @else {

    @if (petsHistory()) {
      @let items = petsFormatted();

      @if (items.length > 0) {
        <div class="survey-history__list">
          @for (item of items; track item.id) {
            <article class="survey-history__item">
              <div
                class="survey-history__status
                {{ item.statusClass }}"
              >
                {{ item.status }}
              </div>

              <div class="survey-history__pet">
                <lib-icon
                  class="
                  survey-history__pet-icon
                  {{ item.iconClass }}
                "
                  [iconName]="item.iconName"
                  aria-hidden="true"
                ></lib-icon>

                <div class="survey-history__pet-content">
                  @if (allowAnimalNavigation() && item.id) {
                    <button
                      type="button"
                      class="survey-history__pet-name survey-history__pet-link"
                      [attr.aria-label]="
                      'View ' + item.animalName + ' pet profile'
                    "
                      (click)="onViewAnimal(item.id)"
                    >
                      {{ item.animalName }}
                    </button>
                  } @else {
                    <p class="survey-history__pet-name">
                      {{ item.animalName }}
                    </p>
                  }

                  @if (item.animalDetails) {
                    <p class="survey-history__pet-details">
                      {{ item.animalDetails }}
                    </p>
                  }

                  <span class="survey-history__pet-details"><strong>Petszel ID:</strong> {{ item.id }}</span>

                  @if (
                    allowImpersonation() &&
                    item.canImpersonate &&
                    item.id
                    ) {
                    <button
                      type="button"
                      class="petszel-primary-button"
                      [attr.aria-label]="'Impersonate ' + item.animalName"
                      (click)="onImpersonate(item.id)"
                    >
                      Impersonate
                    </button>
                  }
                </div>
              </div>

              <div class="survey-history__event-details">
                @if (item.latestEvent) {
                  <span>{{ item.latestEvent }}</span>
                  @if (item.latestSubEvent) {
                    <span>{{ item.latestSubEvent }}</span>
                  }
                  @if (item.latestEventDate) {
                    <span>{{ item.latestEventDate }} CST</span>
                  }
                }
              </div>
            </article>
          }
        </div>
      } @else {
        <p class="survey-history__message">No animal history available.</p>
      }
    } @else {
      <div class="survey-history__loading">
        <lib-new-loading></lib-new-loading>
      </div>
    }
  }
</section>
